import GoogleMapsApiLoader from './google-maps-api-loader';

var geocoder = null

function _doGeocode(options, onlyFirstResult = true) {
  return GoogleMapsApiLoader.getApi()
    .then(() => {
      if(! geocoder) geocoder = new google.maps.Geocoder;

      return new Promise((resolve, reject) => {
        geocoder.geocode(options,
          (results, status) => {
            if(status == 'ZERO_RESULTS' || results == null || results.length == 0)
              reject('ZERO_RESULTS')
            else
              resolve(onlyFirstResult ? results[0] : results)
          },
          (error) => {
            reject(error)
          })
      })
    })
}

// Forward geocoding
export function getPlaceFromAddress(address, componentRestrictions, onlyFirstResult) {
  return _doGeocode({address, componentRestrictions}, onlyFirstResult)
}

// Reverse geocoding
export function getPlaceFromCoOrds(lat, lng, componentRestrictions, onlyFirstResult) {
  let options = {
    location: {lat, lng},
    componentRestrictions,
  }
  return _doGeocode(options, onlyFirstResult)
}

export function convertPlaceToAddress(place) {
  return {
    name: place.name,
    latitude: place.geometry.location.lat(),
    longitude: place.geometry.location.lng(),
    formattedAddress: place.formatted_address,
    recommedViewport: {
      north: place.geometry.viewport.getNorthEast().lat(),
      east: place.geometry.viewport.getNorthEast().lng(),
      south: place.geometry.viewport.getSouthWest().lat(),
      west: place.geometry.viewport.getSouthWest().lng(),
    },

    streetNumber: findPlaceComponent(place, 'street_number'),
    street: findPlaceComponent(place, 'route'),
    city: findPlaceComponent(place, ['sublocality', 'locality']),
    postalCode: findPlaceComponent(place, 'postal_code'),
    country: findPlaceComponent(place, 'country'),
  }
}

function findPlaceComponent(place, searchItems) {
  searchItems = [].concat(searchItems);
  for (var i = 0; i < searchItems.length; i++) {
    let searchItem = searchItems[i];
    let matched = place.address_components
      .find(com => com.types.indexOf(searchItem) >= 0);

    if(matched) return matched.long_name;
  } 
}

export function isValidStreetAddress(address) {
  return address.streetNumber && address.street && address.city && address.country;
}